import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_GET_FBP_ELIGIBILITY_CONFIG);
var axios_instance_delete = get_axios_instance(api_variables.SERVICE_DELETE_FBP_ELIGIBILTY_CONFIG);
var axios_instance_create = get_axios_instance(api_variables.SERVICE_ADD_FBP_ELIGIBILITY_CONFIG);
var axios_instance_fbp = get_axios_instance(api_variables.SERVICE_GET_FBP_COMPONENTS);
var axios_instance_getAll = get_axios_instance(api_variables.SERVICE_GET_BY_LE_ID);

const _pk_name = "id";

const state = {
  data: [],
  entitywiseData:[],
  isFetching: false,
  isSaving: false,
  isDeleting: false,
  editMode: false,
  fbpData: [],
  record: {}
};

const getters = {
  editMode: (state) => {
    return state.editMode
  },
  record: (state) => {
    return state.record
  }
}

const mutations = {
  set: (state, payload) => {
    state.data = payload;
  },

  setData: (state, payload) => {
    state.entitywiseData = payload;
  },

  setFbp: (state, payload) => {
    state.fbpData = payload;
  },

  addFbpEligibilityConfig: (state, payload) => {
    state.data.push(payload);
  },

  updateFbpEligibilityConfig: (state, payload) => {
    for (let i = 0; i < state.data.length; i++) {
      if (state.data[i][_pk_name] === payload.id) {
        state.data.splice(i, 1, payload);
      }
    }
  },

  removeFbpEligibilityConfig: (state, payload) => {
    for (let i = 0; i < state.data.length; i++) {
      if (state.data[i][_pk_name] == payload) {
        state.data.splice(i, 1);
      }
    }
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },

  setEditMode: (state, payload) => {
    state.editMode = payload.editMode;
    state.record = payload.record;
}
}

const actions = {
  async fetchAll({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_fbp.get(`/`, {
        params: {
          le_id: payload 
        }
      });
      //console.log(res.data);
      commit("setFetching", false);
      if (res.status == 200) {
        commit("setFbp",[res.data.payload.data, payload]);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async fetchAllFbpData({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_getAll.get(`/`,{
        params: {
          le_id: payload 
        }
      });
      //console.log(res.data);
      commit("setFetching", false);
      if (res.status == 200) {
        commit("setData",[res.data.payload.data, payload]);
      }
      return res;
    } catch (error) {
      throw errorHandler(error);
    }
  },


  async fetchData({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: 
          payload  
      });
      commit("setFetching", false);
      if (res.status == 200) {
        commit("set",[res.data.payload.data, payload]);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async create({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_create.post(`/`, 
        payload
      );
      commit("setSaving", false);
      if (res.status == 200) {
        commit("addFbpEligibilityConfig", res.data.payload.data);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async delete({ commit }, payload) {
    try {
      commit("setDeleting", true);
      let res = await axios_instance_delete.delete(`/${payload}`);
      commit("setDeleting", false);
      if (res.status == 200) {
        commit("removeFbpEligibilityConfig", [payload]);
      }
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async changeEditMode({ commit }, payload) {
        
    try {
        commit("setEditMode", payload);
    } catch (error) {
        throw errorHandler(error.response);
    }
}
}

export default {
  namespaced: true,
  state, mutations, actions, getters
}
